<template>
  <div>
    <div v-if="asyncDataStatus_ready" class="cms">
      <v-row justify="space-between">
        <v-col cols="12" sm="10" md="6">
          <v-row>
            <v-col cols="12">
              <DateTimeSelector
                labelDate="Od"
                :date="startDate"
                :time="startTime"
                @change="updateStartDateTime"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <DateTimeSelector
                labelDate="Do"
                :date="endDate"
                :time="endTime"
                @change="updateEndDateTime"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-select
                :items="usersWithNull"
                item-text="name"
                item-value="val"
                v-model="user"
                label="Uporabnik"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-select
                :items="electronicDevicesWithNull"
                item-text="name"
                item-value="val"
                v-model="electronicDevice"
                label="Blagajna"
              ></v-select>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="auto">
          <v-row>
            <v-col cols="12">
              <v-btn
                color="#0F998E"
                class="white--text mt-2 float-right d-inlineblock"
                @click="search"
              >
                Išči
                <v-icon right dark>fas fa-search</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="py-0">
              <v-btn
                v-if="!loading && reportData.length"
                color="#0F998E"
                class="white--text mt-2 float-right d-inlineblock"
                @click="print"
              >
                Tiskaj
                <v-icon right dark>fas fa-print</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" v-show="loading">
          <AppSpinner />
        </v-col>
        <v-col cols="12" v-show="!loading">
          <ReportTotalRow :total="total" v-if="!loading && reportData.length" />
          <ReportUsersItemRow v-for="item in reportData" :key="item.name"
            :item="item"
          />
        </v-col>
      </v-row>
    </div>

    <div class="print">
      <ReportPrintUsers :data="reportData" :params="params" v-if="reportData" />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import DateTimeSelector from '@/components/DateTimeSelector'
import ReportUsersItemRow from '@/components/ReportUsersItemRow'
import ReportTotalRow from '@/components/ReportTotalRow'
import ReportPrintUsers from '@/components/ReportPrintUsers'

export default {
  components: {
    AppSpinner: () => import('@/components/AppSpinner'),
    ReportPrintUsers,
    DateTimeSelector,
    ReportUsersItemRow,
    ReportTotalRow
  },
  mixins: [
    asyncDataStatus
  ],
  data () {
    return {
      electronicDevicesWithNull: [],
      electronicDevice: null,
      usersWithNull: [],
      user: null,
      startDate: '',
      startTime: '00:00',
      endDate: '',
      endTime: '23:59',
      reportData: [],
      loading: false
    }
  },
  computed: {
    electronicDevices () {
      return Object.values(this.$store.state.devices.items)
    },
    users () {
      return Object.values(this.$store.state.users.items)
    },
    total () {
      return this.reportData.reduce((total, item) => total + item.total, 0)
    },
    params () {
      return {
        startDate: this.startDate,
        startTime: this.startTime,
        endDate: this.endDate,
        endTime: this.endTime,
        type: 'USERS',
        electronicDevice: this.electronicDevice,
        user: this.user ? { id: this.user } : null
      }
    }
  },
  methods: {
    ...mapActions('devices', { loadDevices: 'loadItems' }),
    ...mapActions('users', { loadUsers: 'loadItems' }),
    ...mapActions('reports', ['generateReport', 'updatePrintData']),
    updateStartDateTime ({ date, time }) {
      this.startDate = date
      this.startTime = time
    },
    updateEndDateTime ({ date, time }) {
      this.endDate = date
      this.endTime = time
    },
    search () {
      return new Promise((resolve, reject) => {
        this.loading = true
        this.reportData = []
        this.generateReport(this.params)
          .then(response => {
            this.loading = false
            if (response) {
              this.reportData = response
            }
            resolve()
          })
          .catch(anErr => {
            this.loading = false
            this.$notify({
              type: 'error',
              text: 'Prišlo je do napake pri generiranju izpisa.'
            })
            resolve()
          })
      })
    },
    print () {
      // let routeData = this.$router.resolve({ name: 'MyCompanyReportsPrint', query: { params: JSON.stringify(this.params) } })
      // window.open(routeData.href, '_blank')
      window.print()
    }
  },
  created () {
    if (!this.$store.state.businessUnits.currentBusinessUnit) {
      this.$notify({ type: 'error', text: 'Potrebna je vsaj ena aktivna poslovna enota' })
    } else {
      const today = moment().format('YYYY-MM-DD')
      this.startDate = today
      this.endDate = today
      Promise.all([
        this.loadDevices(),
        this.loadUsers()
      ])
        .then(response => {
          this.electronicDevicesWithNull.push({
            name: 'Vse naprave',
            val: null
          })
          this.electronicDevices.forEach(device => {
            this.electronicDevicesWithNull.push({
              name: `${device.name} (${device.electronic_device_id})`,
              val: device.id
            })
          })
          this.usersWithNull.push({
            name: 'Vsi uporabniki',
            val: null
          })
          this.users.forEach(user => {
            let name = user.moniker
            if (user.complete_name) {
              name += ` - ${user.complete_name}`
            }
            this.usersWithNull.push({
              name,
              val: user.id
            })
          })
          this.search()
            .then(() => {
              this.asyncDataStatus_fetched()
            })
        })
        .catch(anErr => {
          this.$notify({
            type: 'error',
            text: 'Prišlo je do napake pri nalaganju podatkov.'
          })
        })
    }
  },
  watch: {
    /* startDate: {
      handler (newVal) {
        if (newVal) this.search()
      },
      immediate: true
    },
    startTime (newVal) {
      if (newVal) this.search()
    },
    endDate (newVal) {
      if (newVal) this.search()
    },
    endTime (newVal) {
      if (newVal) this.search()
    },
    electronicDevice () {
      if (this.asyncDataStatus_ready) this.search()
    },
    user () {
      if (this.asyncDataStatus_ready) this.search()
    } */
  }
}
</script>

<style lang="scss" scoped>
.print {
  display: none;
}
@media print {
  .print {
    display: block;
  }
}
</style>

<style lang="scss">
@media print {
  .cms,
  .header,
  .v-navigation-drawer,
  .footer {
    display: none;
  }
  .v-content {
    padding: 0px !important;
  }
}
</style>
